import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[68px]">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-black text-lg tracking-tight transition-colors ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料入口
              </span>
              <span
                className={`text-[11px] font-label tracking-widest transition-colors ${
                  solid ? "text-foreground-500" : "text-background-200"
                }`}
              >
                HEILIAO · 备用导航
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3.5 py-2 text-sm font-label rounded-md transition-colors ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#entries"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-links-line" />
              获取最新入口
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
                solid
                  ? "text-foreground-800 bg-background-100"
                  : "text-background-50 bg-background-50/15"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-2 text-sm font-label text-foreground-700 border-b border-background-100 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entries"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium"
            >
              <i className="ri-links-line" />
              获取最新入口
            </a>
          </div>
        </div>
      )}
    </header>
  );
}